import React from 'react';
import { Search } from 'lucide-react';
import { SearchResult, Conversation } from '../utils/types';
import SearchResults from './SearchResults';

interface SearchBarProps {
    placeholder: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    showResults?: boolean;
    searchResults?: SearchResult[];
    conversations?: Conversation[];
    onResultClick?: (conversationId: number, messageId: number) => void;
    className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
                                                 placeholder,
                                                 value,
                                                 onChange,
                                                 showResults = false,
                                                 searchResults = [],
                                                 conversations = [],
                                                 onResultClick = () => {},
                                                 className = "w-64"
                                             }) => {
    return (
        <div className="relative">
            <input
                type="text"
                placeholder={placeholder}
                className={`pl-10 pr-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300 ${className}`}
                value={value}
                onChange={onChange}
            />
            <div className="absolute left-3 top-2.5 text-gray-400">
                <Search size={18} />
            </div>

            {showResults && searchResults.length > 0 && (
                <SearchResults
                    results={searchResults}
                    conversations={conversations}
                    onResultClick={onResultClick}
                />
            )}
        </div>
    );
};

export default SearchBar;